//common
const HOME = "/";
const SIGNUP = "/signup";
const STUDENTUPLOAD = "/upload"
const VERIFY = "/verify/:token"

export const paths = {
    HOME,
    SIGNUP,
    STUDENTUPLOAD,
    VERIFY
};
